module.exports = __webpack_public_path__ + "assets/img/Exchange_btn.33e34b90.png";